// Helper functions to create scale and value converters
const createScaleConverter = (maxValue) => (value) => {
    const rounded = Math.round(value)
    return Number(Math.round((100 / maxValue) * (rounded || 0)));

};

const createValueGetter = () => (value) => {
    return value || 0;
};

// Overall Health Score
const getOverallHealthColor = (value) => {
    if (!value && value !== 0) return 'gray';    // loading/unknown state
    if (value > 77.5) return '#008000';          // very good (dark green)
    if (value > 65) return '#A6E177';            // good (light green)
    if (value > 45) return '#F2BF3A';            // moderate (yellow)
    if (value > 25) return '#F34848';            // poor (orange)
    return '#FF0000';                            // very poor (red)
};

const getOverallHealthStatus = (value) => {
    if (!value && value !== 0) return 'Loading...';
    if (value > 77.5) return 'Very Good';
    if (value > 65) return 'Good';
    if (value > 45) return 'Moderate';
    if (value > 25) return 'Poor';
    return 'Very Poor';
};

const overallHealthScale = createScaleConverter(100);
const overallHealthValue = createValueGetter();

// Heart Health Functions
const getHeartHealthColor = (value) => {
    if (!value && value !== 0) return '#gray';
    if (value >= 6.6) return '#F34848';    // very high risk
    if (value >= 3.3) return '#FF8C00';    // high risk
    if (value >= 2.39) return '#F2BF3A';   // moderate risk
    if (value >= 1.65) return '#A6E177';   // low risk
    return '#50BA47';                      // very low risk
};

const getHeartHealthStatus = (value) => {
    if (!value && value !== 0) return 'Loading...';
    if (value >= 6.6) return 'Very High Risk';
    if (value >= 3.3) return 'High Risk';
    if (value >= 2.39) return 'Moderate Risk';
    if (value >= 1.65) return 'Low Risk';
    return 'Very Low Risk';
};

const heartHealthScale = createScaleConverter(5);
const heartHealthValue = createValueGetter();

// Body Function Functions
const getBodyFunctionColor = (value) => {
    if (!value && value !== 0) return '#gray';
    if (value >= 4.5) return '#50BA47';    // excellent
    if (value >= 3.5) return '#A6E177';    // good
    if (value >= 2.5) return '#F2BF3A';    // moderate
    if (value >= 1.5) return '#A6E177';    // fair
    return '#F34848';                      // poor
};

const getBodyFunctionStatus = (value) => {
    if (!value && value !== 0) return 'Loading...';
    if (value >= 4.5) return 'Excellent';
    if (value >= 3.5) return 'Good';
    if (value >= 2.5) return 'Moderate';
    if (value >= 1.5) return 'Fair';
    return 'Poor';
};

const bodyFunctionScale = createScaleConverter(5);
const bodyFunctionValue = createValueGetter();

// Physical Health Functions
const getPhysicalHealthColor = (value) => {
    if (!value && value !== 0) return '#gray';
    if (value >= 4.5) return '#50BA47';     // excellent
    if (value >= 3) return '#A6E177';     // good
    if (value >= 2) return '#F2BF3A';     // moderate
    if (value >= 1) return 'F2BF3A';     // fair
    return '#F34848';                      // poor
};

const getPhysicalHealthStatus = (value) => {
    if (!value && value !== 0) return 'Loading...';
    if (value >= 4.5) return 'Excellent';
    if (value >= 3) return 'Good';
    if (value >= 2) return 'Moderate';
    if (value >= 1) return 'Fair';
    return 'Poor';
};

const physicalHealthScale = createScaleConverter(5);
const physicalHealthValue = createValueGetter();


// Disease Risk Functions
//const getDiseaseRiskColor = ( value ) => {
//  if ( !value && value !== 0 ) return '#gray';
//  if ( value >= 4 ) return '#FF0000';   // very high risk
//  if ( value >= 3 ) return '#FF8C00';     // high risk
////  if ( value >= 2 ) return '#FFD700';     // moderate risk
//  if ( value >= 1 ) return '#90EE90';     // low risk
//  return '#50BA47';                      // very low risk
//};
//
//const getDiseaseRiskStatus = ( value ) => {
//  if ( !value && value !== 0 ) return 'Loading...';
//  if ( value >= 4 ) return 'Very High Risk';
//  if ( value >= 3 ) return 'High Risk';
////  if ( value >= 2 ) return 'Moderate Risk';
//  if ( value >= 1 ) return 'Low Risk';
//  return 'Very Low Risk';
//};

const getDiseaseRiskColor = (value) => {
    if (!value && value !== 0) return '#gray';
    if (value >= 29) return '#F34848';   // very high risk
    if (value >= 19) return '#FF8C00';     // high risk
    if (value >= 15) return '#F2BF3A';     // moderate risk
    if (value >= 9) return '#A6E177';     // low risk
    return '#50BA47';                      // very low risk
}

const getDiseaseRiskStatus = (value) => {
    if (!value && value !== 0) return 'Loading...';
    if (value >= 29) return 'Very High Risk';
    if (value >= 19) return 'High Risk';
    if (value >= 15) return 'Moderate Risk';
    if (value >= 9) return 'Low Risk';
    return 'Very Low Risk';
};
const diseaseRiskScale = createScaleConverter(5);
const diseaseRiskValue = createValueGetter();

// Liver Health Functions
const getLiverHealthColor = (value) => {
    if (!value && value !== 0) return 'gray';
    if (value > 77.5) return '#FF0000';     // very high
    if (value > 55) return '#FFA500';       // high
    if (value > 45) return '#F2BF3A';       // moderate
    if (value > 25) return '#008000';       // low
    return '#90EE90';                       // very low
};

const getLiverHealthStatus = (value) => {
    if (!value && value !== 0) return 'Loading...';
    if (value > 77.5) return 'very high';
    if (value > 55) return 'high';
    if (value > 45) return 'moderate';
    if (value > 25) return 'low';
    return 'very low';
};
const liverHealthScale = createScaleConverter(5);
const liverHealthValue = createValueGetter();

// Diabetes Risk Functions


// const getDiabetesScoreColor = (value) => {
//     // Ensure value is a valid number
//     if (value === undefined || value === null || isNaN(value)) return '#gray';

//     // Adjusted color ranges based on the 0-5 scale
//     if (value >= 0 && value < 1.0) return '#F34848';   // Very Poor (Highest risk)
//     if (value >= 1.0 && value < 2.0) return '#F34848';   // Very Poor
//     if (value >= 2.0 && value < 3.0) return '#F2BF3A';   // Poor
//     if (value >= 3.0 && value < 4.0) return '#F2BF3A';   // Fair
//     if (value >= 4.0 && value < 5.0) return '#A6E177';   // Good
//     if (value >= 5.0) return '#50BA47';                  // Excellent (Lowest risk)

//     return '#gray';  // Default color for invalid value
// };
const getDiabetesScoreColor = ( value ) => {
    if ( !value && value !== 0 ) return '#gray';
    if (value < 25) return  '#50BA47';  // very low
    if (value >= 25 && value < 45) return '#A6E177';  // low
    if (value >= 45 && value < 55) return '#F2BF3A';    // moderate risk
    if (value >= 55 && value < 77.5) return '#FF8C00'; // high risk
    if (value >= 77.5 && value <= 100) return '#F34848'; // very high risk
    return '#FF0000';                      // very high risk
  };
  


const getDiabetesScoreStatus = ( value ) => {
    if ( !value && value !== 0 ) return 'Loading...';
    if (value < 25) return "Very Low Risk"
    if (value >= 25 && value < 45) return 'Low Risk';  // low
    if (value >= 45 && value < 55) return 'Moderate Risk';    // moderate risk
    if (value >= 55 && value < 77.5) return 'High Risk'; // high risk
    if (value >= 77.5 && value <= 100) return 'Very High Risk'; // very high risk
    return 'Very High Risk';
  };

// const getDiabetesScoreStatus = (value) => {
//     // Ensure value is a valid number
//     if (value === undefined || value === null || isNaN(value)) return '...Loading';

//     // Adjusted ranges for a 0-5 scale:
//     // 0 corresponds to Very Poor, 5 corresponds to Excellent

//     if (value == 0) return "Very Poor";               // Very High Risk (lowest score)
//     if (value > 0 && value <= 1) return "Very Poor";   // Very High Risk
//     if (value > 1 && value <= 2) return "Poor";        // High Risk
//     if (value > 2 && value <= 3) return "Fair";        // Moderate Risk
//     if (value > 3 && value <= 4) return "Good";        // Low Risk
//     if (value > 4 && value <= 5) return "Excellent";   // Very Low Risk (best health)

//     return "Excellent";  // Fallback in case of invalid input (should never reach here)
// };

const diabetesRiskScale = createScaleConverter(100);
const diabetesRiskValue = createValueGetter();

//Mental Score

const getMentalScoreColor = (value) => {
    if (value === undefined || value === null || isNaN(value)) return '#gray';
    if (value >= 0 && value < 1.0) return '#F34848';  
    if (value >= 1.0 && value < 2.0) return '#F34848';   
    if (value >= 2.0 && value < 3.0) return '#F2BF3A';   
    if (value >= 3.0 && value < 4.0) return '#F2BF3A';   
    if (value >= 4.0 && value < 5.0) return '#A6E177';   
    if (value >= 5.0) return '#50BA47';                 
    return '#gray';
};

const getMantalScoreStatus = (value) => {
    if (value === undefined || value === null || isNaN(value)) return '...Loading';
    if (value >= 0 && value < 1.0) return "Very Poor";
    if (value >= 1.0 && value < 2.0) return "Very Poor";
    if (value >= 2.0 && value < 3.0) return "Poor";
    if (value >= 3.0 && value < 4.0) return "Fair";
    if (value >= 4.0 && value < 5.0) return "Good";
    if (value >= 5.0) return "Excellent";
    return "Excellent";
};
const mentalRiskScale = createScaleConverter(5);
const mentalRiskValue = createValueGetter();



// Function to get the appropriate functions based on card type
const getAtplHealthFunctions = (cardType) => {
    switch (cardType.toLowerCase()) {
        case 'overall health score':
            return {
                getColor: getOverallHealthColor,
                getStatus: getOverallHealthStatus,
                getScaledValue: overallHealthScale,
                getValue: overallHealthValue
            };
        case 'heart health':
            return {
                getColor: getHeartHealthColor,
                getStatus: getHeartHealthStatus,
                getScaledValue: heartHealthScale,
                getValue: heartHealthValue
            };
        case 'body function':
            return {
                getColor: getBodyFunctionColor,
                getStatus: getBodyFunctionStatus,
                getScaledValue: bodyFunctionScale,
                getValue: bodyFunctionValue
            };
        case 'physical health':
            return {
                getColor: getPhysicalHealthColor,
                getStatus: getPhysicalHealthStatus,
                getScaledValue: physicalHealthScale,
                getValue: physicalHealthValue
            };
        case 'overall disease risk':
            return {
                getColor: getDiseaseRiskColor,
                getStatus: getDiseaseRiskStatus,
                getScaledValue: diseaseRiskScale,
                getValue: diseaseRiskValue
            };
        case 'liver health':
            return {
                getColor: getLiverHealthColor,
                getStatus: getLiverHealthStatus,
                getScaledValue: liverHealthScale,
                getValue: liverHealthValue
            };
        case 'diabetes':
            return {
                getColor: getDiabetesScoreColor,
                getStatus: getDiabetesScoreStatus,
                getScaledValue: diabetesRiskScale,
                getValue: diabetesRiskValue
            };
        case 'mental health':
            return {
                getColor: getMentalScoreColor,
                getStatus: getMantalScoreStatus,
                getScaledValue: mentalRiskScale,
                getValue: mentalRiskValue

            };
        default:
            return {
                getColor: () => '#gray',
                getStatus: () => 'Unknown',
                getScaledValue: (value) => value,
                getValue: (value) => value || 0
            };
    }
};

export default getAtplHealthFunctions;